export default {
    listagem: {
        titulo_pagina: 'Resultados Desechables',
        table: {
            empty: 'No se encontraron Vns',
            nome: 'Vns',
            empresa: 'Empresa',
            resultado_descartavel: 'Resultado Desechable',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Editar Resultados Desechables'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Nombre del Vns'
            },
            report_trash: {
                label: 'Resultados Desechables',
                description: 'Resultados que serán descartados por vns'
            },
            botao_salvar : 'Guardar Resultados Desechables'
        },
        update: {
            success: '¡Resultados desechables actualizados con éxito!',
            error: '¡Error al actualizar los resultados desechables!'
        }
    }
}